import { useToken } from '@ori/auth';
import type { ConfigValues } from '@ori/back-in-stock-notification';
import { BackInStockNotificationController } from '@ori/back-in-stock-notification';
import type { parseSpaConfig } from '@ori-appshell/config';
import type { FC } from 'react';

import { APP_NAME } from './constants';

export type AppProps = ReturnType<typeof parseSpaConfig<ConfigValues>>;

export const App: FC<AppProps> = ({
  currentLanguage,
  graphqlUrl,
  notifyMeSubscriptionConfiguration,
  tenant,
  onlineBaseUrl,
  staticApiUrl,
}) => {
  const { customerId, token } = useToken();

  if (!token) {
    return null;
  }

  return (
    <BackInStockNotificationController
      currentLanguage={currentLanguage}
      graphqlUrl={graphqlUrl}
      notifyMeSubscriptionConfiguration={notifyMeSubscriptionConfiguration}
      tenant={tenant}
      token={token}
      appName={APP_NAME}
      onlineBaseUrl={onlineBaseUrl}
      customerId={customerId}
      staticApiUrl={staticApiUrl}
    />
  );
};
